import type { SerializedStyles, Theme } from '@emotion/react'
import { css } from '@emotion/react'

import * as styles from '@twisto/styles'

import type { Colors } from './message-box'

export const box = css`
  display: grid;
  position: relative;
  width: 100%;
  grid-template-columns: max-content 1fr;
  grid-template-rows: 1fr;
  column-gap: ${styles.size[8]};
  align-items: center;
  padding: ${styles.size[8]} ${styles.size[16]};
`

export const background: Record<Colors, (theme: Theme) => SerializedStyles> = {
  primary: (theme) => css`
    background-color: ${theme.palette.brand[100]};
  `,
  success: (theme) => css`
    background-color: ${theme.palette.success[100]};
  `,
  warning: (theme) => css`
    background-color: ${theme.palette.warning[100]};
  `,
  gray: (theme) => css`
    background-color: ${theme.palette.neutral[200]};
  `,
}
